
import { useSearchParams } from 'react-router-dom';

import { IUtmDataValues } from 'api/curo/ApplyProcessApi';
import SessionStorageKey from 'enums/SessionStorageKey';

const useUtmSource = () => {
  const [searchParams] = useSearchParams();

  const addUtmQueryToStorage = () => {
    const utmSource = searchParams.get(SessionStorageKey.UtmSource);
    const utmMedium = searchParams.get(SessionStorageKey.UtmMedium);
    const utmCampaign = searchParams.get(SessionStorageKey.UtmCampaign);

    if (utmSource) {
      sessionStorage.setItem(SessionStorageKey.UtmSource, utmSource);
    };
    if (utmMedium) {
      sessionStorage.setItem(SessionStorageKey.UtmMedium, utmMedium);
    };
    if (utmCampaign) {
      sessionStorage.setItem(SessionStorageKey.UtmCampaign, utmCampaign);
    };
  };

  const getUtmData = (): IUtmDataValues => {
    const utmSource = sessionStorage.getItem(SessionStorageKey.UtmSource);
    const utmMedium = sessionStorage.getItem(SessionStorageKey.UtmMedium);
    const utmCampaign = sessionStorage.getItem(SessionStorageKey.UtmCampaign);

    return ({
      utmSource: utmSource || null,
      utmMedium: utmMedium || null,
      utmCampaign: utmCampaign || null,
    });
  };

  const setUtmQueryToURL = () => {
    const { utmSource, utmMedium, utmCampaign } = getUtmData();

    if (utmSource || utmMedium || utmCampaign) {
      const queryParams = new URLSearchParams({ 
        ...utmSource && { [SessionStorageKey.UtmSource]: utmSource }, 
        ...utmMedium && { [SessionStorageKey.UtmMedium]: utmMedium },
        ...utmCampaign && { [SessionStorageKey.UtmCampaign]: utmCampaign },
      });

      return queryParams.toString();
    };

    return '';
  };

  return ({
    addUtmQueryToStorage,
    setUtmQueryToURL,
    getUtmData,
  });
};

export default useUtmSource;
